import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BASE_URL = 'https://www.gurukrupaeducation.com/api';

const ChecklistEditor = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const fetchItems = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/get_checklist.php`);
      setItems(res.data);
    } catch (err) {
      console.error(err);
      setMessage('Failed to load checklist');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const handleLabelChange = (index, value) => {
    const updated = [...items];
    updated[index] = { ...updated[index], label: value };
    setItems(updated);
  };

  const addItem = () => {
    setItems([...items, { label: '', sort_order: items.length }]);
  };

  const removeItem = (index) => {
    if (!window.confirm('Delete this item?')) return;
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
  };

  const moveUp = (index) => {
    if (index === 0) return;
    const updated = [...items];
    [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
    setItems(updated);
  };

  const moveDown = (index) => {
    if (index === items.length - 1) return;
    const updated = [...items];
    [updated[index], updated[index + 1]] = [updated[index + 1], updated[index]];
    setItems(updated);
  };

  const saveItems = async () => {
    if (!window.confirm('This will overwrite all existing checklist items. Continue?')) return;

    try {
      const res = await axios.post(`${BASE_URL}/save_checklist.php`, {
        items: items.map((it, idx) => ({
          label: it.label,
          sort_order: idx,
        })),
      });
      setMessage(res.data.message || 'Checklist saved!');
      fetchItems();
    } catch (err) {
      console.error(err);
      setMessage('Save failed.');
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ padding: '20px' }}>
      <h2>Edit Confirmation Checklist</h2>
      {message && <p><strong>{message}</strong></p>}

      <button onClick={addItem} style={{ marginBottom: '10px' }}>+ Add Item</button>
      <button onClick={saveItems} style={{ marginLeft: '10px', marginBottom: '10px', background: 'green', color: '#fff', border: 'none', padding: '8px 16px', cursor: 'pointer' }}>
        💾 Save All
      </button>

      <table border="1" cellPadding="6" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Order</th>
            <th>Statement</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={idx}>
              <td style={{ textAlign: 'center' }}>
                <button onClick={() => moveUp(idx)} disabled={idx === 0}>▲</button>
                <button onClick={() => moveDown(idx)} disabled={idx === items.length - 1}>▼</button>
              </td>
              <td>
                <textarea
                  value={item.label}
                  onChange={(e) => handleLabelChange(idx, e.target.value)}
                  rows={3}
                  style={{ width: '100%', resize: 'vertical' }}
                />
              </td>
              <td>
                <button onClick={() => removeItem(idx)} style={{ color: 'red' }}>✕</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ChecklistEditor;